import { ReactNode, useRef, useState } from 'react';

interface AgencyCodesTooltipProps {
  children: ReactNode;
  text: string;
}

//Overflow tooltip local to Agency Codes; kept out of the shared Tooltip component so this page's
//Figma styling never affects other pages that reuse Foundation/Common/Tooltip.
export function AgencyCodesTooltip(props: AgencyCodesTooltipProps) {
  const cellRef = useRef<HTMLDivElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const updateOverflowState = () => {
    const el = cellRef.current;
    const div = el?.querySelector('div');
    setIsOverflowing(Boolean(div && div.scrollWidth > div.clientWidth));
  };

  return (
    <div
      ref={cellRef}
      onMouseEnter={updateOverflowState}
      onMouseLeave={() => setIsOverflowing(false)}
      onFocus={updateOverflowState}
      onBlur={() => setIsOverflowing(false)}
      tabIndex={0}
      className="agency-codes-tooltip-wrapper"
    >
      {isOverflowing && <span className="agency-codes-tooltiptext">{props.text}</span>}
      {props.children}
    </div>
  );
}
